export function removeMarkdown(markdownText: string): string {
    return markdownText
      .replace(/!\[.*?\]\(.*?\)/g, "") // Remove images
      .replace(/\[.*?\]\(.*?\)/g, "") // Remove links
      .replace(/(\*\*|__)(.*?)\1/g, "$2") // Remove bold
      .replace(/(\*|_)(.*?)\1/g, "$2") // Remove emphasis (italic)
      .replace(/~~(.*?)~~/g, "$1") // Remove strikethrough
      .replace(/`{1,2}(.*?)`{1,2}/g, "$1") // Remove inline code
      .replace(/```[\s\S]*?```/g, "") // Remove code blocks
      .replace(/^[#]{1,6}\s*(.*)/gm, "$1") // Remove headings
      .replace(/[-+*]\s+/g, "") // Remove unordered list markers
      .replace(/\d+\.\s+/g, "") // Remove ordered list markers
      .replace(/>\s+/g, "") // Remove blockquotes
      .replace(/\n{2,}/g, "\n") // Remove extra line breaks
      .replace(/^\s+|\s+$/g, ""); // Trim leading/trailing whitespace
  }